module.exports = __webpack_public_path__ + "static/media/cams_omc_logo.ef898da1.png";


//////////////////
// WEBPACK FOOTER
// ./src/AntD/assets/img/cams_omc_logo.png
// module id = 816
// module chunks = 0